
import React, { useState, useEffect } from 'react';
import { Maximize, Minimize } from 'lucide-react';
import { Button } from './ui/button';
import { useIsMobile } from '@/hooks/use-mobile';

const FullscreenControl: React.FC = () => {
  const [isFullscreen, setIsFullscreen] = useState<boolean>(false);
  const isMobile = useIsMobile();

  // Check fullscreen status when component mounts and when it changes
  useEffect(() => {
    const handleFullscreenChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
    };
  }, []);

  // Hide on mobile - moved after all hooks
  if (isMobile) {
    return null;
  }

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      // Enter fullscreen
      document.documentElement.requestFullscreen().catch(err => {
        console.error(`Error attempting to enable fullscreen: ${err.message}`);
      });
    } else {
      // Exit fullscreen
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    }
  };

  return (
    <Button 
      onClick={toggleFullscreen}
      variant="ghost" 
      size="icon"
      className="fixed bottom-4 right-4 z-50 bg-black/30 backdrop-blur-sm rounded-full border border-white/30 hover:bg-black/40 h-10 w-10"
      aria-label={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}
    >
      {isFullscreen ? (
        <Minimize className="h-5 w-5 text-white" />
      ) : (
        <Maximize className="h-5 w-5 text-white" />
      )}
    </Button>
  );
};

export default FullscreenControl;
